module.exports = __webpack_public_path__ + "static/media/pie_chart.9e8e2f08.svg";